import styled from 'styled-components';

const Root = styled.div `
  background-color: ${props => props.theme.colors.gray0};

  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

export { Root };
